import React, { useEffect, useState } from 'react';
import { LinkedinIcon, TwitterIcon, MailIcon, CalendarIcon, ClockIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export const Founder = () => {
  const [showScheduler, setShowScheduler] = useState(false);
  const [bookingComplete, setBookingComplete] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const handleBookingSubmit = e => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setBookingComplete(true);
      setIsSubmitting(false);
    }, 1500);
  };
  return <section className="bg-[#f2efeb] py-14 md:py-24 border-t border-[#d9d3cb]" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20" data-id="element-141">
          <div className="order-2 lg:order-1" data-id="element-142">
            <p className="text-xs sm:text-sm tracking-widest uppercase text-[#c9a875] font-medium mb-4" data-id="element-143">
              Leadership
            </p>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif-display text-[#2b2826] leading-tight mb-6" data-id="element-144">
              The Vision Behind{' '}
              <span className="italic text-[#c9a875]" data-id="element-145">ScaleWithLending</span>
            </h2>

            <div className="space-y-6 text-lg text-[#2b2826]/80 font-light leading-relaxed" data-id="element-146">
              <p data-id="element-147">
                With over 5 years of experience in real estate investing and
                private lending, Cam founded ScaleWithLending to solve a
                critical problem he experienced firsthand: the lack of
                accessible, flexible funding for real estate professionals.
              </p>
              <p data-id="element-148">
                His mission is to empower wholesalers and investors with capital
                solutions that remove barriers and accelerate deal
                closings—without the red tape of traditional financing.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 sm:gap-6 mt-10 pt-8 border-t border-[#2b2826]/15" data-id="element-149">
              <div data-id="element-150">
                <p className="font-serif-display text-3xl sm:text-4xl text-[#2b2826] mb-1" data-id="element-151">
                  200+
                </p>
                <p className="text-xs sm:text-sm text-[#2b2826]/60 leading-tight" data-id="element-152">
                  Transactions Completed
                </p>
              </div>
              <div data-id="element-153">
                <p className="font-serif-display text-3xl sm:text-4xl text-[#2b2826] mb-1" data-id="element-154">
                  11
                </p>
                <p className="text-xs sm:text-sm text-[#2b2826]/60 leading-tight" data-id="element-155">
                  Properties in Portfolio
                </p>
              </div>
              <div data-id="element-156">
                <p className="font-serif-display text-3xl sm:text-4xl text-[#2b2826] mb-1" data-id="element-157">
                  5+ <span className="text-xl sm:text-2xl" data-id="element-158">Yrs</span>
                </p>
                <p className="text-xs sm:text-sm text-[#2b2826]/60 leading-tight" data-id="element-159">
                  Industry Experience
                </p>
              </div>
            </div>

            <div className="pt-8 mt-8 border-t border-[#2b2826]/15" data-id="element-160">
              <p className="font-serif-display text-2xl text-[#2b2826]" data-id="element-161">
                Cameron Enck
              </p>
              <p className="text-[#c9a875] font-medium text-sm tracking-wide mt-1" data-id="element-162">
                Founder
              </p>
              <p className="text-[#2b2826]/60 text-sm mt-2" data-id="element-163">
                Also founder of{' '}
                <span className="text-[#2b2826]/80" data-id="element-164">Tru Offer</span> &{' '}
                <span className="text-[#2b2826]/80" data-id="element-165">AcquireFlow.AI</span>
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-166">
            <div className="relative z-10" data-id="element-167">
              <div className="aspect-[4/5] relative overflow-hidden rounded-2xl bg-[#2b2826]" data-id="element-168">
                <img src="https://cdn.magicpatterns.com/uploads/dApiLVLjau7driRrjXyRXK/Black_and_White_Modern_Man_YouTube_Profile_Picture_(1).png" alt="Cameron Enck, Founder of ScaleWithLending" className="w-full h-full object-cover" style={{
                mixBlendMode: 'lighten'
              }} data-id="element-169" />
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-170" />
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-[#c9a875]/10 rounded-full blur-2xl -z-10" data-id="element-171" />
          </div>
        </div>

        {/* Scheduler Section */}
        <div className="mt-24" data-id="element-172">
          <div className="text-center mb-12" data-id="element-173">
            <h3 className="text-3xl md:text-4xl font-bold mb-4 font-serif-display text-[#2b2826]" data-id="element-174">
              Book a Strategy Call
            </h3>
            <p className="text-xl text-[#2b2826]/70 max-w-2xl mx-auto" data-id="element-175">
              Schedule a 15-minute call with our team to discuss your funding
              needs and how we can help you scale.
            </p>
          </div>

          {showScheduler ? <div className="bg-[#2b2826] rounded-2xl p-6 sm:p-10 border border-[#403a35] max-w-2xl mx-auto" data-id="element-176">
              <div className="flex justify-between items-center mb-8" data-id="element-177">
                <h4 className="text-2xl font-bold text-[#f2efeb]" data-id="element-178">
                  Select a Time
                </h4>
                <button onClick={() => setShowScheduler(false)} className="text-[#f2efeb]/60 hover:text-[#f2efeb] transition-colors" data-id="element-179">
                  Cancel
                </button>
              </div>

              {!bookingComplete ? <form onSubmit={handleBookingSubmit} className="space-y-6" data-id="element-180">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-181">
                    <div data-id="element-182">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-2" data-id="element-183">
                        Date
                      </label>
                      <div className="relative" data-id="element-184">
                        <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#c9a875] w-5 h-5" data-id="element-185" />
                        <select className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl pl-10 pr-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875] appearance-none" data-id="element-186">
                          <option data-id="element-187">
                            Tomorrow,{' '}
                            {new Date(Date.now() + 86400000).toLocaleDateString()}
                          </option>
                          <option data-id="element-188">
                            {new Date(Date.now() + 172800000).toLocaleDateString()}
                          </option>
                          <option data-id="element-189">
                            {new Date(Date.now() + 259200000).toLocaleDateString()}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div data-id="element-190">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-2" data-id="element-191">
                        Time
                      </label>
                      <div className="relative" data-id="element-192">
                        <ClockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#c9a875] w-5 h-5" data-id="element-193" />
                        <select className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl pl-10 pr-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875] appearance-none" data-id="element-194">
                          <option data-id="element-195">10:00 AM EST</option>
                          <option data-id="element-196">11:30 AM EST</option>
                          <option data-id="element-197">1:00 PM EST</option>
                          <option data-id="element-198">3:30 PM EST</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-4" data-id="element-199">
                    <div data-id="element-200">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-2" data-id="element-201">
                        Name
                      </label>
                      <input type="text" required className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="John Doe" data-id="element-202" />
                    </div>
                    <div data-id="element-203">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-2" data-id="element-204">
                        Email
                      </label>
                      <input type="email" required className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="john@example.com" data-id="element-205" />
                    </div>
                    <div data-id="element-206">
                      <label className="block text-sm font-medium text-[#f2efeb]/80 mb-2" data-id="element-207">
                        Phone
                      </label>
                      <input type="tel" required className="w-full bg-[#1c1916] border border-[#403a35] rounded-2xl px-4 py-3 text-[#f2efeb] focus:outline-none focus:border-[#c9a875]" placeholder="(555) 123-4567" data-id="element-208" />
                    </div>
                  </div>

                  <button type="submit" className="w-full bg-[#c9a875] text-white font-medium py-4 px-8 rounded-full hover:bg-[#b08e5c] transition-colors flex items-center justify-center gap-2" data-id="element-209">
                    Confirm Booking
                    <ArrowRightIcon className="w-5 h-5" data-id="element-210" />
                  </button>
                </form> : <div className="text-center py-8" data-id="element-211">
                  <div className="w-20 h-20 bg-[#c9a875]/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-212">
                    <CheckCircleIcon className="w-10 h-10 text-[#c9a875]" data-id="element-213" />
                  </div>
                  <h4 className="text-2xl font-bold text-[#f2efeb] mb-4" data-id="element-214">
                    Call Scheduled!
                  </h4>
                  <p className="text-[#f2efeb]/70 mb-8" data-id="element-215">
                    We've sent a calendar invitation with the Zoom link to your
                    email. We look forward to speaking with you.
                  </p>
                  <div className="bg-[#1c1916] rounded-2xl p-6 text-left border border-[#403a35]" data-id="element-216">
                    <div className="flex items-center gap-3 mb-3" data-id="element-217">
                      <CalendarIcon className="w-5 h-5 text-[#c9a875]" data-id="element-218" />
                      <span className="text-[#f2efeb]" data-id="element-219">
                        Tomorrow,{' '}
                        {new Date(Date.now() + 86400000).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-220">
                      <ClockIcon className="w-5 h-5 text-[#c9a875]" data-id="element-221" />
                      <span className="text-[#f2efeb]" data-id="element-222">10:00 AM EST</span>
                    </div>
                  </div>
                </div>}
            </div> : <div className="bg-[#2b2826] rounded-2xl p-8 border border-[#403a35] text-center max-w-2xl mx-auto" data-id="element-223">
              <div className="w-20 h-20 bg-[#c9a875]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-224">
                <CalendarIcon className="w-10 h-10 text-[#c9a875]" data-id="element-225" />
              </div>
              <h4 className="text-2xl font-bold text-[#f2efeb] mb-4" data-id="element-226">
                Ready to scale your business?
              </h4>
              <p className="text-[#f2efeb]/70 mb-8" data-id="element-227">
                Book a free 15-minute strategy session to discuss your funding
                needs and see if we're a good fit.
              </p>
              <button onClick={() => setShowScheduler(true)} className="inline-flex items-center justify-center gap-3 bg-[#c9a875] text-white font-medium py-4 px-8 rounded-full hover:bg-[#b08e5c] transition-colors" data-id="element-228">
                <CalendarIcon className="w-5 h-5" data-id="element-229" />
                Find a Time
              </button>
            </div>}
        </div>
      </div>
    </section>;
};